/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderConfirmationPageContainerStyles } from "@monsma/Overrides/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.container = {
    gap: 0,
};

orderConfirmationPageContainerStyles.headerGridItem = {
    width: 12,
};

orderConfirmationPageContainerStyles.accountSignUpGridItem = {
    width: 12,
};

orderConfirmationPageContainerStyles.orderInformationGridItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        @media print {
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            display: block !important;
        }
    `,
};

orderConfirmationPageContainerStyles.orderTotalGridItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        @media print {
            flex-basis: 100%;
            max-width: 100%;
            width: 100%;
            display: block !important;
        }
    `,
};

orderConfirmationPageContainerStyles.productListGridItem = {
    width: 12,
};

orderConfirmationPageContainerStyles!.xOrderConfirmationPageContainer = {
    orderInfoTotalGridItem: {
        width: 12,
    },
    orderInfoTotalContainer: {
        gap: 60,
    },
};
